import { render, staticRenderFns } from "./goods-edit.vue?vue&type=template&id=c67b7354"
import script from "./goods-edit.vue?vue&type=script&lang=js"
export * from "./goods-edit.vue?vue&type=script&lang=js"
import style0 from "./goods-edit.vue?vue&type=style&index=0&id=c67b7354&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports